import { createReducer } from 'redux-act';
import actions from '../actions/KudosActions';

const initialState = {
    addKudosCategoryPending: false,
    addKudosCategoryRes: null,
    addKudosCategoryError: null,

    getKudosCategoryPending: false,
    getKudosCategoryRes: null,
    getKudosCategoryError: null,

    createKudosPending: false,
    createKudosRes: null,
    createKudosError: null,

    getKudosDataPending: false,
    getKudosDataRes: null,
    getKudosDataError: null,

    addKudosPointHistoryPending: false,
    addKudosPointHistoryRes: null,
    addKudosPointHistoryError: null,

    getPointStatementPending: false,
    getPointStatementRes: null,
    getPointStatementError: null,

    getUserKudosOnTypePending: false,
    getUserKudosOnTypeRes: null,
    getUserKudosOnTypeError: null,

    approveRejectKudosPending: false,
    approveRejectKudosRes: null,
    approveRejectKudosError: null,

};
/* Add Kudos Category Reducers */
const handleAddKudosCategoryRequest = state => {
    return {
        ...state,
        ...{
            addKudosCategoryPending: true,
            addKudosCategoryRes: null,
            addKudosCategoryError: null,
        },
    };
};
const handleAddKudosCategorySuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addKudosCategoryPending: false,
            addKudosCategoryRes: payload,
            addKudosCategoryError: null,
        },
    };
};
const handleAddKudosCategoryError = (state, payload) => ({
    ...state,
    ...{
        addKudosCategoryPending: false,
        addKudosCategoryRes: null,
        addKudosCategoryError: payload,
    },
});


/* Get Kudos Category Reducers */
const handleGetKudosCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            getKudosCategoryPending: true,
            getKudosCategoryRes: null,
            getKudosCategoryError: null,
        },
    };
};
const handleGetKudosCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKudosCategoryPending: false,
            getKudosCategoryRes: payload,
            getKudosCategoryError: null,
        },
    };
};
const handleGetKudosCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        getKudosCategoryPending: false,
        getKudosCategoryRes: null,
        getKudosCategoryError: payload,
    },
});

/* Create Kudos Reducers */
const handleCreateKudosRequest = state1 => {
    return {
        ...state1,
        ...{
            createKudosPending: true,
            createKudosRes: null,
            createKudosError: null,
        },
    };
};
const handleCreateKudosSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createKudosPending: false,
            createKudosRes: payload,
            createKudosError: null,
        },
    };
};
const handleCreateKudosError = (state1, payload) => ({
    ...state1,
    ...{
        createKudosPending: false,
        createKudosRes: null,
        createKudosError: payload,
    },
});

/* Given Kudos Reducers */
const handleGetKudosDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getKudosDataPending: true,
            getKudosDataRes: null,
            getKudosDataError: null,
        },
    };
};
const handleGetKudosDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKudosDataPending: false,
            getKudosDataRes: payload,
            getKudosDataError: null,
        },
    };
};
const handleGetKudosDataError = (state1, payload) => ({
    ...state1,
    ...{
        getKudosDataPending: false,
        getKudosDataRes: null,
        getKudosDataError: payload,
    },
});

/* Add Kudos Point History Reducers*/
const handleAddKudosPointHistoryRequest = state1 => {
    return {
        ...state1,
        ...{
            addKudosPointHistoryPending: true,
            addKudosPointHistoryRes: null,
            addKudosPointHistoryError: null,
        },
    };
};
const handleAddKudosPointHistorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addKudosPointHistoryPending: false,
            addKudosPointHistoryRes: payload,
            addKudosPointHistoryError: null,
        },
    };
};
const handleAddKudosPointHistoryError = (state1, payload) => ({
    ...state1,
    ...{
        addKudosPointHistoryPending: false,
        addKudosPointHistoryRes: null,
        addKudosPointHistoryError: payload,
    },
});


/* Get Point Statement Reducers*/
const handleGetPointStatementRequest = state1 => {
    return {
        ...state1,
        ...{
            getPointStatementPending: true,
            getPointStatementRes: null,
            getPointStatementError: null,
        },
    };
};
const handleGetPointStatementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getPointStatementPending: false,
            getPointStatementRes: payload,
            getPointStatementError: null,
        },
    };
};
const handleGetPointStatementError = (state1, payload) => ({
    ...state1,
    ...{
        getPointStatementPending: false,
        getPointStatementRes: null,
        getPointStatementError: payload,
    },
});


/* Get Point Statement Reducers*/
const handleGetUserKudosOnTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            getUserKudosOnTypePending: true,
            getUserKudosOnTypeRes: null,
            getUserKudosOnTypeError: null,
        },
    };
};
const handleGetUserKudosOnTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getUserKudosOnTypePending: false,
            getUserKudosOnTypeRes: payload,
            getUserKudosOnTypeError: null,
        },
    };
};
const handleGetUserKudosOnTypeError = (state1, payload) => ({
    ...state1,
    ...{
        getUserKudosOnTypePending: false,
        getUserKudosOnTypeRes: null,
        getUserKudosOnTypeError: payload,
    },
});

/* Get Point Statement Reducers*/
const handleApproveRejectKudosRequest = state1 => {
    return {
        ...state1,
        ...{
            approveRejectKudosPending: true,
            approveRejectKudosRes: null,
            approveRejectKudosError: null,
        },
    };
};
const handleApproveRejectKudosSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            approveRejectKudosPending: false,
            approveRejectKudosRes: payload,
            approveRejectKudosError: null,
        },
    };
};
const handleApproveRejectKudosError = (state1, payload) => ({
    ...state1,
    ...{
        approveRejectKudosPending: false,
        approveRejectKudosRes: null,
        approveRejectKudosError: payload,
    },
});


// Clear Existing Data Store Reducers*/
const clearKudosStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_KUDOS_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    addKudosCategoryPending: false,
                    addKudosCategoryRes: null,
                    addKudosCategoryError: null,
                },
            };

        case 'HANDLE_CLEAR_GET_KUDOS_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    getKudosCategoryPending: false,
                    getKudosCategoryRes: null,
                    getKudosCategoryError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_KUDOS_STORE':
            return {
                ...state,
                ...{
                    createKudosPending: false,
                    createKudosRes: null,
                    createKudosError: null,
                },
            };
        case 'HANDLE_CLEAR_ADD_KUDOS_POINT_HISTORY_STORE':
            return {
                ...state,
                ...{
                    addKudosPointHistoryPending: false,
                    addKudosPointHistoryRes: null,
                    addKudosPointHistoryError: null,
                },
            };
            case 'HANDLE_CLEAR_APPROVE_REJECT_KUDOS_STORE':
                return {
                    ...state,
                    ...{
                        approveRejectKudosPending: false,
                        approveRejectKudosRes: null,
                        approveRejectKudosError: null,
                    },
                };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addKudosCategoryRequest]: handleAddKudosCategoryRequest,
        [actions.addKudosCategorySuccess]: handleAddKudosCategorySuccess,
        [actions.addKudosCategoryError]: handleAddKudosCategoryError,

        [actions.getKudosCategoryRequest]: handleGetKudosCategoryRequest,
        [actions.getKudosCategorySuccess]: handleGetKudosCategorySuccess,
        [actions.getKudosCategoryError]: handleGetKudosCategoryError,

        [actions.createKudosRequest]: handleCreateKudosRequest,
        [actions.createKudosSuccess]: handleCreateKudosSuccess,
        [actions.createKudosError]: handleCreateKudosError,

        [actions.getKudosDataRequest]: handleGetKudosDataRequest,
        [actions.getKudosDataSuccess]: handleGetKudosDataSuccess,
        [actions.getKudosDataError]: handleGetKudosDataError,

        [actions.addKudosPointHistoryRequest]: handleAddKudosPointHistoryRequest,
        [actions.addKudosPointHistorySuccess]: handleAddKudosPointHistorySuccess,
        [actions.addKudosPointHistoryError]: handleAddKudosPointHistoryError,

        [actions.getPointStatementRequest]: handleGetPointStatementRequest,
        [actions.getPointStatementSuccess]: handleGetPointStatementSuccess,
        [actions.getPointStatementError]: handleGetPointStatementError,

        [actions.getUserKudosOnTypeRequest]: handleGetUserKudosOnTypeRequest,
        [actions.getUserKudosOnTypeSuccess]: handleGetUserKudosOnTypeSuccess,
        [actions.getUserKudosOnTypeError]: handleGetUserKudosOnTypeError,

        [actions.approveRejectKudosRequest]: handleApproveRejectKudosRequest,
        [actions.approveRejectKudosSuccess]: handleApproveRejectKudosSuccess,
        [actions.approveRejectKudosError]: handleApproveRejectKudosError,


        [actions.handleClearKudosStore]: clearKudosStore,
    },
    initialState,
);